@let cols = columns();
@let fil = filters();

<div class="flex min-w-0 flex-1 flex-col">
  <ng-content select="[before-table]"></ng-content>

  <div class="flex-1 p-6">
    <aura-data-table
      matSort
      [searchPlaceHolder]="'Rechercher par nom, prénom, email, numéro'"
      [inputColumns]="cols"
      [filters]="fil"
      [items]="items()"
      [count]="count()"
      [loading]="isLoading()"
      [pagination]="pagination()"
      [topButtons]="topButtons()"
      [itemActions]="itemActions()"
      [mappedFilters]="mappedFilters()"
      [rowClickable]="rowClickable()"
      (removeFilter)="removeFilter()?.($event)"
      (clearFiltering)="clearFiltering()?.()"
      (triggerRefresh)="triggerRefresh()?.()"
      (triggerFiltering)="triggerFiltering()?.()"
      (filterViewChanged)="filterViewChanged()?.($event)"
      (itemClicked)="itemClicked()?.($event)"
      (pageChanged)="pageChanged()?.($event)"
      (searchChanged)="searchChanged()?.($event)"
      (matSortChange)="sortChanged()?.($event)"
    >
      <ng-template #filterTemplate>
        <etxe-agents-data-table-filter
          [dto]="appliedFilter()"
          [filters]="fil"
          [currentFilterView]="currentFilterView()"
          (filterChanged)="filterChanged()?.($event)"
        />
      </ng-template>

      @for (column of cols; track $index) {
        @if (!column.native) {
          <ng-container [matColumnDef]="column.key">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              [sortActionDescription]="'Trier par ' + column.label | lowercase"
              class="font-bold! text-indigo-11!"
            >
              {{ column.label }}
            </th>
            @switch (column.key) {
              @case ('firstName') {
                <td mat-cell *matCellDef="let agent" class="py-4">
                  @if (agent.user?.identity; as identity) {
                    <div class="flex items-center gap-3">
                      <aura-avatar
                        [label]="identity.firstName"
                        [srcImage]="$safeNavigationMigration(identity.avatar?.url)"
                        [size]="'s'"
                      />
                      <span class="font-medium text-gray-12">
                        {{ identity.firstName | titlecase }}
                      </span>
                    </div>
                  } @else {
                    <span class="italic text-xs text-gray-9">-</span>
                  }
                </td>
              }
              @case ('lastName') {
                <td mat-cell *matCellDef="let agent" class="py-4">
                  @if (agent.user?.identity; as identity) {
                    <div class="flex items-center gap-3">
                      <span class="font-medium text-gray-12">
                        {{ identity.lastName | titlecase }}
                      </span>
                    </div>
                  } @else {
                    <span class="italic text-xs text-gray-9">-</span>
                  }
                </td>
              }
              @case ('email') {
                <td mat-cell *matCellDef="let agent" class="py-4">
                  @if (agent.user?.contactInfos; as contactInfos) {
                    <div class="flex items-center gap-3">
                      <span class="font-medium text-gray-12">
                        {{ contactInfos.email }}
                      </span>
                    </div>
                  } @else {
                    <span class="italic text-xs text-gray-9">-</span>
                  }
                </td>
              }
              @case ('createdAt') {
                <td mat-cell *matCellDef="let agent">
                  {{ agent.createdAt | luxonDate: 'humanize' }}
                </td>
              }
              @case ('type') {
                <td mat-cell *matCellDef="let agent">
                  <span class="capitalize">{{ agent.type }}</span>
                </td>
              }
              @case ('region') {
                <td mat-cell *matCellDef="let agent" class="py-3">
                  @let regionName = getPrimaryRegionName(agent);
                  @let depts = getCoveredDepartments(agent);
                  @if (regionName || depts.length > 0) {
                    <div class="flex flex-col gap-1 max-w-xs">
                      @if (regionName) {
                        <div class="flex items-center gap-1.5 min-w-0">
                          <mat-icon class="!w-4 !h-4 !text-base text-primary-11 shrink-0">explore</mat-icon>
                          <span class="font-semibold text-xs text-neutral-12 truncate">{{ regionName }}</span>
                        </div>
                      }
                      @if (depts.length > 0) {
                        <div
                          class="flex items-center flex-wrap gap-1"
                          [matTooltip]="getAllDepartmentsTooltip(agent)"
                        >
                          @for (dept of depts.slice(0, 3); track dept) {
                            <span
                              class="px-1.5 py-0.5 rounded bg-neutral-2 text-neutral-11 text-[11px] font-mono border border-neutral-3"
                            >
                              {{ dept }}
                            </span>
                          }
                          @if (depts.length > 3) {
                            <span class="text-[11px] text-neutral-9 font-medium">
                              +{{ depts.length - 3 }}
                            </span>
                          }
                        </div>
                      }
                    </div>
                  } @else {
                    <span class="italic text-xs text-gray-9">-</span>
                  }
                </td>
              }
              @default {
                <td mat-cell *matCellDef="let agent">{{ agent[column.key] }}</td>
              }
            }
          </ng-container>
        }
      }
    </aura-data-table>
  </div>
</div>
